export default "__VITE_ASSET__ae0c60aa__"